/* TBP FOXPOST shipping progress — read the actual post-add Shopify AJAX cart totals. */
(() => {
  const currency = new Intl.NumberFormat('hu-HU', { maximumFractionDigits: 0 });
  const formatHuf = (cents) => currency.format(Math.ceil(cents / 100)) + ' Ft';

  function paint(element, cart) {
    if (!element || !cart || !Number.isFinite(Number(cart.total_price))) return;
    if (!Number(cart.item_count)) {
      element.hidden = true;
      return;
    }
    const threshold = Number(element.dataset.thresholdCents) || 1500000;
    const total = Math.max(0, Number(cart.total_price));
    const remaining = Math.max(0, threshold - total);
    const percentage = Math.max(0, Math.min(100, Math.floor((total / threshold) * 100)));
    const message = element.querySelector('[data-tbp-shipping-message]');
    const bar = element.querySelector('[role="progressbar"]');
    const fill = element.querySelector('[data-tbp-shipping-fill]');
    if (!message || !bar || !fill) return;

    const highlight = document.createElement('strong');
    highlight.className = 'tbp-shipping-progress__highlight';
    if (remaining > 0) {
      highlight.textContent = formatHuf(remaining);
      message.replaceChildren(
        document.createTextNode('Már csak '),
        highlight,
        document.createTextNode(' hiányzik az ingyenes FOXPOST automatás szállításig.')
      );
    } else {
      highlight.textContent = 'Elérted!';
      message.replaceChildren(
        highlight,
        document.createTextNode(' Az ingyenes FOXPOST automatás szállítás feltétele teljesült.')
      );
    }

    element.classList.toggle('is-unlocked', remaining === 0);
    bar.setAttribute('aria-valuenow', String(percentage));
    fill.style.width = percentage + '%';
    element.hidden = false;
  }

  async function refresh() {
    const notification = document.getElementById('cart-notification');
    if (!notification || !notification.classList.contains('active')) return;
    const element = notification.querySelector('[data-tbp-shipping-progress]');
    if (!element) return;
    try {
      const route = window.routes?.cart_url || '/cart';
      const response = await fetch(route + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Cart AJAX status ' + response.status);
      const cart = await response.json();
      if (notification.classList.contains('active')) paint(element, cart);
    } catch (error) {
      element.hidden = true;
      console.warn('TBP FOXPOST jelző: a kosáradat nem tölthető be.', error);
    }
  }

  function initialize() {
    const notification = document.getElementById('cart-notification');
    if (!notification) return;
    let wasOpen = false;
    const observer = new MutationObserver(() => {
      const isOpen = notification.classList.contains('active');
      if (isOpen && !wasOpen) refresh();
      wasOpen = isOpen;
    });
    observer.observe(notification, { attributes: true, attributeFilter: ['class'] });
    if (notification.classList.contains('active')) {
      wasOpen = true;
      refresh();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
